import { render, staticRenderFns } from "./dialogAddUser.vue?vue&type=template&id=0c0841cc&scoped=true&"
import script from "./dialogAddUser.vue?vue&type=script&lang=js&"
export * from "./dialogAddUser.vue?vue&type=script&lang=js&"
import style0 from "./dialogAddUser.vue?vue&type=style&index=0&id=0c0841cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0841cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VSpacer,VTextField})
